/**
 * Função para controlar o acesso de perfis aos módulos
 * @param {string} modulo - Nome do módulo a ser verificado
 * @param {string} perfil - Perfil do usuário logado
 * @returns {boolean} - Retorna true se o perfil tem acesso ao módulo
 */
export const verificarAcessoModulo = (modulo, perfil) => {
  // Mapeamento de módulos e perfis permitidos
  const permissoesModulos = {
    // Módulo de Empresas
    empresas: {
      perfisPermitidos: ['superusuario', 'admin'],
      descricao: 'Gerenciamento de Empresas'
    },
    // Módulo de Usuários
    usuarios: {
      perfisPermitidos: ['superusuario', 'admin'],
      descricao: 'Gerenciamento de Usuários'
    },
    // Módulo de Clientes
    clientes: {
      perfisPermitidos: ['superusuario', 'admin', 'operador'],
      descricao: 'Gerenciamento de Clientes'
    },
    // Módulo de Colaboradores
    colaboradores: {
      perfisPermitidos: ['superusuario', 'admin'],
      descricao: 'Gerenciamento de Colaboradores'
    },
    // Módulo de Serviços
    servicos: {
      perfisPermitidos: ['superusuario', 'admin', 'operador'],
      descricao: 'Gerenciamento de Serviços'
    },
    // Módulo de Agendamentos
    agendamentos: {
      perfisPermitidos: ['superusuario', 'admin', 'operador'],
      descricao: 'Gerenciamento de Agendamentos'
    },
    // Módulo de Turmas
    turmas: {
      perfisPermitidos: ['superusuario', 'admin', 'operador'],
      descricao: 'Gerenciamento de Turmas'
    },
    // Módulo Financeiro
    financeiro: {
      perfisPermitidos: ['superusuario', 'admin'],
      descricao: 'Gerenciamento Financeiro'
    },
    // Módulo Financeiro
    atendimentoindividual: {
      perfisPermitidos: ['superusuario', 'admin', 'operador', 'guest'],
      descricao: 'Atendimento ao cliente'
    },
    formularioatendimento: {
      perfisPermitidos: ['superusuario', 'admin', 'operador', 'guest'],
      descricao: 'Formulário de Atendimento'
    },
    // Módulo de Agendamento Individual
    agendamentoindividual: {
      perfisPermitidos: ['superusuario', 'admin', 'operador', 'guest'],
      descricao: 'Agendamento Individual'
    },
    // Associar serviço ao colaborador
    servicocolaborador: {
      perfisPermitidos: ['superusuario', 'admin', 'operador'],
      descricao: 'Associar serviço ao colaborador'
    },
    // Módulo de Categorias
    categorias: {
      perfisPermitidos: ['superusuario', 'admin'],
      descricao: 'Gerenciamento de Categorias'
    },
    // Módulo de Disponibilidade Semanal de Colaboradores
    dispsemanalcolab: {
      perfisPermitidos: ['superusuario', 'admin', 'operador'],
      descricao: 'Disponibilidade Semanal de Colaboradores'
    },
    // Módulo de Locais
    locais: {
      perfisPermitidos: ['superusuario', 'admin', 'operador'],
      descricao: 'Gerenciamento de Locais'
    },
    // Módulo de Registro de Frequência
    registrofrequencia: {
      perfisPermitidos: ['superusuario', 'admin', 'operador'],
      descricao: 'Registro de Frequência de Alunos'
    },
    // Módulo Dashboard
    dashboard: {
      perfisPermitidos: ['superusuario', 'admin', 'operador', 'guest'],
      descricao: 'Painel Principal do Sistema'
    },
    // Módulo de Gestão de Módulos
    modulos: {
      perfisPermitidos: ['superusuario'],
      descricao: 'Gestão de Módulos do Sistema'
    },
    // Módulo de Empresa
    empresamodulo: {
      perfisPermitidos: ['superusuario'],
      descricao: 'Módulo de Empresa'
    },
    // Módulo de Lista de Agenda por Colaborador
    listaagendacolaborador: {
      perfisPermitidos: ['superusuario', 'admin', 'operador', 'guest'],
      descricao: 'Lista de Agenda por Colaborador'
    },
    // Módulo de Relatório de Empresas
    relatorioempresas: {
      perfisPermitidos: ['superusuario'],
      descricao: 'Relatórios de Empresas'
    },
    // Módulo de Relatório de Serviços
    relatorioservicos: {
      perfisPermitidos: ['superusuario', 'admin', 'operador'],
      descricao: 'Relatórios de Serviços'
    },
    // Módulo de Matrícula
    matricula: {
      perfisPermitidos: ['superusuario', 'admin', 'operador'],
      descricao: 'Gestão de Matrículas'
    },
    // Módulo de Horário de Atendimento
    horarioatendimento: {
      perfisPermitidos: ['superusuario', 'admin', 'operador'],
      descricao: 'Gestão de Horários de Atendimento'
    },
    // Módulo de Recuperação de Usuários
    recuperarusuario: {
      perfisPermitidos: ['superusuario', 'admin'],
      descricao: 'Recuperação de Usuários Inativos'
    },
    // Módulo de Produtos MAD (Madeireira)
    prodmad: {
      perfisPermitidos: ['superusuario', 'admin', 'operador'],
      descricao: 'Cadastro de Produtos (MAD)'
    },
    kitmad: {
      perfisPermitidos: ['superusuario', 'admin', 'operador'],
      descricao: 'Monstagem de kits (MAD)'
    },
    orcmad: {
      perfisPermitidos: ['superusuario', 'admin', 'operador'],
      descricao: 'Orçamento'
    },
    chat: {
      perfisPermitidos: ['superusuario', 'admin', 'operador'],
      descricao: 'Chat Corporativo'
    }
  };

  // Se o módulo não estiver mapeado, nega o acesso
  if (!permissoesModulos[modulo]) {
    console.warn(`Módulo ${modulo} não está mapeado nas permissões`);
    return false;
  }

  // Verifica se o perfil está na lista de perfis permitidos
  const temAcesso = permissoesModulos[modulo].perfisPermitidos.includes(perfil);

  // Se não tiver acesso, registra no console
  if (!temAcesso) {
    console.warn(`Perfil ${perfil} não tem acesso ao módulo ${modulo}`);
  }

  return temAcesso;
};

const getNomeModulo = (modulo) => {
  if (typeof modulo === 'string') return modulo;
  return modulo?.nome || modulo?.st_nome || modulo?.path?.replace(/^\//, '');
};

const usuarioTemModulo = (usuario, modulo) => {
  const modulos = Array.isArray(usuario?.modulos) ? usuario.modulos : [];
  return modulos.some((item) => getNomeModulo(item) === modulo);
};

/**
 * Função simplificada para verificar acesso do usuário a um módulo
 * @param {string} modulo - Nome do módulo a ser verificado
 * @returns {boolean} - Retorna true se o usuário tem acesso ao módulo
 */
export const verificarAcessoUsuario = (modulo) => {
  try {
    const usuario = JSON.parse(localStorage.getItem("usuario"));
    const perfil = usuario?.perfil;

    if (!perfil) {
      console.warn('Usuário não está logado ou não possui perfil definido');
      return false;
    }

    // Se for superusuário, tem acesso a tudo
    if (perfil === 'superusuario') {
      return true;
    }

    const temAcesso = usuarioTemModulo(usuario, modulo);

    if (!temAcesso) {
      console.warn(`Perfil de Gestão do usuário não tem acesso ao módulo ${modulo}`);
    }

    return temAcesso;
  } catch (error) {
    console.error('Erro ao verificar acesso do usuário:', error);
    return false;
  }
};

/**
 * Função para verificar se o usuário tem acesso a um módulo específico (versão completa)
 * @param {Object} params - Parâmetros da verificação
 * @param {Object} params.usuario - Usuário logado
 * @param {string} params.st_codHashEmpresaLocal - Código hash da empresa
 * @param {string} params.modulo - Nome do módulo a ser verificado
 * @param {string} params.acao - Ação a ser realizada (visualizar, criar, editar, excluir)
 * @returns {boolean} - Retorna true se o usuário tem acesso ao módulo
 */
export const verificarAcessoUsuarioCompleto = ({ usuario, st_codHashEmpresaLocal, modulo, acao }) => {
  try {
    const perfil = usuario?.perfil;

    if (!perfil) {
      console.warn('Usuário não está logado ou não possui perfil definido');
      return false;
    }

    // Se for superusuário, tem acesso a tudo
    if (perfil === 'superusuario') {
      return true;
    }

    const temAcessoModulo = usuarioTemModulo(usuario, modulo);
    if (!temAcessoModulo) {
      console.warn(`Perfil de Gestão do usuário não tem acesso ao módulo ${modulo}`);
      return false;
    }

    // Verifica se o usuário pertence à mesma empresa
    if (usuario?.st_codHashEmpresa !== st_codHashEmpresaLocal) {
      console.warn('Usuário não pertence à empresa selecionada');
      return false;
    }

    return true;
  } catch (error) {
    console.error('Erro ao verificar acesso do usuário:', error);
    return false;
  }
};
